<template>
  <ValidationObserver
    ref="modalObserver"
    v-slot="{ valid }"
  >
    <v-dialog
      v-model="mutableIsVisible"
      scrollable
      :persistent="true"
      :width="1126"
      :noClickAnimation="true"
    >
      <form>
        <v-card>
          <v-card-title>
            {{ title }}
          </v-card-title>
          <v-divider />
          <v-card-text class="py-4">
            <SampleForm
              :isEdition="isEdition"
              :isLab="true"
              :isTemplate="true"
              :sample="sample"
              @sendData="updateData($event)"
            />
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <div
              v-if="getTabs.length"
              class="d-flex"
            >
              <v-btn
                v-if="displayPrevious"
                text
                :ripple="false"
                class="btn"
                @click="previous"
              >
                <v-icon
                  class="icon"
                  large
                >
                  arrow_left
                </v-icon>
                <span
                  class="arrow"
                >
                  {{ $t('pagination.previous') }}
                </span>
              </v-btn>
            </div>
            <v-spacer />
            <v-btn
              text
              @click="hide"
            >
              {{ $t('forms.btn.cancel') }}
            </v-btn>
            <v-btn
              v-if="displayNext"
              :disabled="wasValid ? false : !valid"
              color="primary"
              type="submit"
              class="capitalize large"
              @click.prevent="next"
            >
              {{ $t('pagination.next') }}
            </v-btn>
            <v-btn
              v-else
              :disabled="!valid"
              color="primary"
              type="submit"
              @click.prevent="confirm"
            >
              {{ $t(`forms.labels.confirm`) }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </v-dialog>
  </ValidationObserver>
</template>


<script>
import { mapGetters } from 'vuex';
import SampleForm from '@/components/forms/sample/SampleForm';
import { ValidationObserver } from 'vee-validate';

export default {
    components: {
        ValidationObserver,
        SampleForm,
    },
    props: {
        isVisible: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
        sample: {
            type: Object,
            default: () => ({}),
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            mutableIsVisible: null,
            data: {},
            wasValid: false,
            previousValid: [false],
        };
    },
    computed: {
        ...mapGetters([
            'activeTab',
            'getTabs',
            'selectedLang',
        ]),
        displayPrevious() {
            return this.activeTab > 0;
        },
        displayNext() {
            return this.getTabs.length - 1 > this.activeTab;
        },
    },
    watch: {
        isVisible: {
            handler() {
                this.mutableIsVisible = this.isVisible;
            },
            immediate: true,
        },
    },
    methods: {
        hide() {
            this.mutableIsVisible = false;
            this.$emit('hide', this.mutableIsVisible);
        },
        confirm() {
            this.$emit('confirm', this.data);
            // reset sample
            this.$store.dispatch('setSample', {});
            this.$store.dispatch('changeActiveTab', 0);
        },
        updateData(payload) {
            this.data = payload;
        },
        isFormValid(silent = false) {
            return this.$refs.modalObserver.validate({ silent });
        },
        async next() {
            const targetTab = this.activeTab + 1;
            this.$store.dispatch('changeActiveTab', targetTab);
            const valid = await this.isFormValid();
            if (!valid && this.previousValid[targetTab]) {
                this.wasValid = true;
            } else {
                // this.activeTab is not zero indexed
                this.previousValid[this.activeTab - 1] = valid;
                if (this.wasValid) {
                    this.wasValid = false;
                }
            }
        },
        async previous() {
            const targetTab = this.activeTab - 1;
            this.$store.dispatch('changeActiveTab', targetTab);
            const valid = await this.isFormValid();
            if (!valid && this.previousValid[targetTab]) {
            // not valid but the previous step was already validated
                this.wasValid = true;
            }
        },
    },
};
</script>
